import { RegistrationEditMode } from "../store/user-edits/user-edit-types";
import { DecodedDeepLinkData } from "./deep-link-data-decoded";
import { EncodedDeepLinkData, EncodedEditMode } from "./deep-link-data-encoded";

/**
 * @param decodedData The deep link data to encode/compress.
 * @returns the raw, encoded deep link data.
 */
export function encodeDeepLinkData(
  decodedData: DecodedDeepLinkData,
): EncodedDeepLinkData {
  return {
    edit: decodedData.edit ? encodeEditMode(decodedData.edit) : undefined,
  };
}

/**
 * @param decodedEditMode The decoded edit mode to encode.
 * @returns An encoded, compressed version of the edit mode.
 */
export function encodeEditMode(
  decodedEditMode: RegistrationEditMode,
): EncodedEditMode {
  switch (decodedEditMode) {
    case RegistrationEditMode.editScans:
      return EncodedEditMode.editScans;
    case RegistrationEditMode.addConnection:
      return EncodedEditMode.addConnection;
    case RegistrationEditMode.deleteConnection:
      return EncodedEditMode.deleteConnection;
  }
}
